<sc-modal [title]="title" #helpDeskModal [closeButton]="false">
    <div class="help-desk__content">
        <img *ngIf="imageSrc" class="mb-1" [src]="imageSrc" alt="">
        <sc-title [content]="title" type="h2"></sc-title>
        <div class="my-1">
            <p class="mb-0">
                Copiá el error e informalo a la <strong>Mesa de Ayuda</strong>
            </p>
            <p class="mb-0">
                para que podamos solucionarlo cuanto antes.
            </p>
        </div>
        <div class="error-detail">
            <div id="error-message" class="pl-1 pt-1 pb-1 pr-sm-1 pr-md-0">
                <sc-button type="secondary" class="error-detail__floating-copy-button d-sm-none d-md-block"
                    (onClick)="copyToClipboard()">Copiar error</sc-button>
                <p class="error-detail__message mb-0 sc-scroll-bar">
                    {{ errorMessage }}
                </p>
                <div class="w-50">
                    <sc-button type="secondary" class="error-detail__floating-copy-button d-md-none"
                        (onClick)="copyToClipboard()">
                        Copiar error</sc-button>
                </div>
            </div>
        </div>
        <div class="py-1">
            <sc-button type="primary" (onClick)="openHelpDesk()">Informar a la mesa de ayuda</sc-button>
        </div>
        <div class="back-home">
            <sc-button type="link" (onClick)="emitBackToHome()">{{ linkLabel }}</sc-button>
        </div>
    </div>
</sc-modal>